import { Component, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState, selectAuthDataCommonState, selectLanguageInCommonState } from 'app/app-state.index';
import { PermissionsService } from 'app/core/permissions/permissions.service';
import { asyncFilter } from 'app/shared/common/utils';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { AuthData } from 'app/shared/model/auth-data.model';
import { MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { DefaultLayoutComponent } from '../default-layout/default-layout.component';
import { PermissionMenuItem } from '../menu/permission-menu-item';
import { Language, Role } from 'app/shared/model/enums';
import { PermissionType } from 'app/core/permissions/permission-type.enum';


@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class SideMenuComponent {
  menuItems: MenuItem[];
  isMenuOpen: boolean = false;
  _subscriptions = new Subscription();
  _fullMenuItems: PermissionMenuItem[];
  authData: AuthData;
  language: Language
  constructor(public localizationService: LocalizationService, private _cdr: ChangeDetectorRef, public app: DefaultLayoutComponent,
    private store: Store<AppState>, private router: Router, private permissionsService: PermissionsService,
    protected route: ActivatedRoute) {
    this._subscriptions.add(this.store.select(selectAuthDataCommonState).subscribe((authData) => {
      if (this.authData !== authData) {
        this.authData = authData;
        this.isUserAdmin();
        this.initMenu();
        this.initMenuByPermissios();
      }
    }));
    this._subscriptions.add(store.select(selectLanguageInCommonState).subscribe(language => {
      this.language = language
      this.iconMenuSide()
      this.initMenu();
      this.initMenuByPermissios();
    }));
  }
  isUserAdmin() {
    return this.authData.isAtn == true
  }
  iconMenuSide() {
    setTimeout(() => {
      const imgElements = document.querySelectorAll('.menu-icon img') as NodeListOf<HTMLImageElement>;
      imgElements.forEach((imgElement) => {
        if (this.language === Language.en) {
          imgElement.style.transform = 'scaleX(-1)';
        } else {
          imgElement.style.transform = 'scaleX(1)';
        }
      });
      this._cdr.markForCheck();
    }, 1);
  }



  initMenuByPermissios() {
    this.getPermittedMenuItems(this._fullMenuItems).then(menuItems => {
      this.menuItems = menuItems;
      this._cdr.markForCheck();
    });
  }
  async getPermittedMenuItems(menuItems: PermissionMenuItem[]): Promise<MenuItem[]> {
    let permittedItems = await asyncFilter(menuItems, async (item) => {
      if (item.permissionType === Role.Manager) {
        return this.isUserAdmin();
      }
      return !item.permissionType || await this.permissionsService.permissionExists(item.permissionType).toPromise();
    });

    return await Promise.all(permittedItems.map(async (item) => {
      const menuItem = { label: item.label, routerLink: item.routerLink, icon: item.icon, menuItems: null };
      if (item.menuItems) {
        menuItem.menuItems = await this.getPermittedMenuItems(item.menuItems);
      }
      return menuItem;
    }));
  }

  // initMenu() {
  //   this.localizationService.TranslateAsync('MENU').subscribe(translations => {
  //     this._fullMenuItems = [
  //       { label: this.authData.ownerFullName ? this.authData.ownerFullName : translations['PROFILE'], routerLink: ['/webplatform/profile'], icon: 'user-icon' },
  //       { label: translations['ROULLETES'], routerLink: ['/webplatform/my-roulettes'], icon: 'roulette-icon' },
  //       { label: translations['REDEMPTION'], routerLink: ['/webplatform/redem'], icon: 'voucher-icon' },
  //       { label: translations['BUSINESS_CUPON'], routerLink: ['/webplatform/businessCoupons'], icon: 'voucher-icon' },
  //       { label: translations['LIDS'], routerLink: ['/webplatform/leads'], icon: 'leads-icon' },
  //       { label: translations['BUSINESS_MANAGMENT'], routerLink: ['/webplatform/businessManagment'], icon: 'voucher-icon', permissionType: Role.Manager }
  //     ]
  //   })
  // }
  initMenu() {
    this.localizationService.TranslateAsync('MENU').subscribe(translations => {
      const menu: any[] = [
        {
          label: this.authData.ownerFullName ? this.authData.ownerFullName : translations['PROFILE'],
          routerLink: ['/webplatform/profile'],
          icon: 'custom-user-icon'
        },
        {
          label: translations['ROULLETES'],
          routerLink: ['/webplatform/my-roulettes'],
          icon: 'custom-roulette-icon'
        },
        {
          label: translations['REDEMPTION'],
          routerLink: ['/webplatform/redem'],
          icon: 'custom-voucher-icon'
        },
        {
          label: translations['BUSINESS_CUPON'],
          routerLink: ['/webplatform/businessCoupons'],
          icon: 'custom-list-coupon'
        },
        {
          label: translations['LIDS'],
          routerLink: ['/webplatform/leads'],
          icon: 'custom-leads-icon'
        }
      ];

      if (this.isUserAdmin()) {
        menu.push(
          {
            label: translations['BUSINESS_MENU'],
            icon: 'custom-managment',
            items: [
              {
                label: translations['BUSINESS_MANAGMENT'],
                icon: 'custom-business-managment',
                routerLink:'/webplatform/businessManagment'
              }
            ]
          });
      }

      this.menuItems = menu;
    });
  }

  screenBlocked: boolean = false;


  blockScreen() {
    this.screenBlocked = true;
    this._cdr.markForCheck();
  }

  onSelectSubMenuItem(status) {
    this.unBlockScreen();
  }

  unBlockScreen() {
    this.screenBlocked = false;
    this._cdr.markForCheck();
  }

  ngOnDestroy() {
    this._subscriptions.unsubscribe();
  }
  mouseenter() {
    this.openMenu();
  }
  mouseleave() {
    this.closeMenu();
  }
  openMenu() {
    this.isMenuOpen = true;
    //event.preventDefault();
  }
  closeMenu() {
    this.isMenuOpen = false;
    //event.preventDefault();
  }

  onMenuItemClick(event?: MouseEvent) {
    // Close menu on mobile when item is clicked, but not when toggling a submenu panel
    if (window.innerWidth <= 480) {
      const target = event?.target as HTMLElement;
      const panelHeader = target?.closest('.p-panelmenu-header');
      if (panelHeader) {
        const panel = panelHeader.closest('.p-panelmenu-panel');
        const hasChildren = !!panel?.querySelector('.p-panelmenu-content');
        if (hasChildren) {
          // Just a toggle open/close, don't close the sidebar
          return;
        }
      }
      this.closeMenu();
      this._cdr.markForCheck();
    }
  }

}
